import { apiSlice } from "../Api/apiSlice";
import { userLogIn } from "./authSlice";
const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all assignments  records
    register: builder.mutation({
      query: (data) => ({
        url: "/users",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          localStorage.setItem(
            "auth",
            JSON.stringify({
              accessToken: result.data?.accessToken,
              user: result.data?.user,
            })
          );
          dispatch(
            userLogIn({
              accessToken: result.data?.accessToken,
              user: result.data?.user,
            })
          );
        } catch (error) {
          console.log("Register error: ", error);
        }
      },
    }),
    login: builder.mutation({
      query: (data) => ({
        url: "/login",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch, getState }) {
        try {
          const result = await queryFulfilled;

          localStorage.setItem(
            "auth",
            JSON.stringify({
              accessToken: result.data?.accessToken,
              user: result.data?.user,
            })
          );
          dispatch(
            userLogIn({
              accessToken: result.data?.accessToken,
              user: result.data?.user,
            })
          );
        } catch (error) {
          console.log("Student login error: ", error);
        }
      },
    }),
    loginAdmin: builder.mutation({
      query: (data) => ({
        url: "/login",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          localStorage.setItem(
            "auth",
            JSON.stringify({
              accessToken: result.data?.accessToken,
              user: result.data?.user,
            })
          );
          dispatch(
            userLogIn({
              accessToken: result.data?.accessToken,
              user: result.data?.user,
            })
          );
        } catch (error) {
          console.log("Admin Login error: ", error);
        }
      },
    }),
  }),
});

export const { useRegisterMutation, useLoginMutation, useLoginAdminMutation } =
  authApi;
